// extracted by mini-css-extract-plugin
export default {"root":"_2KImc","reaction":"_1A2cZ","reaction-icon":"Ce4HP","reactionIcon":"Ce4HP"};